import React, { useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import EditorJS from '@editorjs/editorjs';

import { addInstructionEventByEditor } from '../utils';
import { InstructionEvent } from '../types';
import {
  setOpenTitleInstructionModal,
  setInlineTitleInstruction,
  setTitleInstructionId,
} from '../../../../store/modules/script-editor/actions';
import { selectTitleInstruction } from '../../../../store/modules/script-editor/selectors';
import { addEventListenerTitleActions } from './utils';
import TitleInstructionModal from './TitleInstructionModal';

type Props = {
  instanceEditor: EditorJS | undefined;
  refEditor: HTMLDivElement | null;
};

const TitleInstructionComponent = ({ instanceEditor, refEditor }: Props) => {
  const dispatch = useDispatch();
  const { isOpenModal } = useSelector(selectTitleInstruction);

  useEffect(() => {
    if (instanceEditor) {
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.OPEN_TITLE_INSTRUCTION_MODAL,
        (data) => {
          dispatch(setOpenTitleInstructionModal(true));
          dispatch(setTitleInstructionId(data.instructionId));
          dispatch(setInlineTitleInstruction(data.isInline));
        },
      );
      addInstructionEventByEditor(
        instanceEditor,
        InstructionEvent.UPDATE_TITLE_ACTION_EVENT_LISTENERS,
        // eslint-disable-next-line
        ({ refEditor, instanceEditor }) => {
          addEventListenerTitleActions({ instanceEditor, refEditor });
        },
      );
    }
  }, [dispatch, instanceEditor]);

  useEffect(() => {
    if (instanceEditor && refEditor) {
      addEventListenerTitleActions({ instanceEditor, refEditor });
    }
  }, [instanceEditor, refEditor]);

  if (!isOpenModal) {
    return null;
  }

  return (
    <TitleInstructionModal instanceEditor={instanceEditor} />
  );
};

export default TitleInstructionComponent;
